var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_174)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_297_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1145 0H4.87266C2.17852 0 0 2.12695 0 4.75664V61.2305C0 63.8602 2.17852 66 4.87266 66H61.1145C63.8086 66 66 63.8602 66 61.2434V4.75664C66 2.12695 63.8086 0 61.1145 0ZM19.5809 56.2418H9.78399V24.7371H19.5809V56.2418ZM14.6824 20.4445C11.5371 20.4445 8.99766 17.9051 8.99766 14.7727C8.99766 11.6402 11.5371 9.10078 14.6824 9.10078C17.8148 9.10078 20.3543 11.6402 20.3543 14.7727C20.3543 17.8922 17.8148 20.4445 14.6824 20.4445ZM56.2418 56.2418H46.4578V40.9277C46.4578 37.2797 46.3934 32.5746 41.366 32.5746C36.2742 32.5746 35.5008 36.5578 35.5008 40.6699V56.2418H25.7297V24.7371H35.1141V29.0426H35.243C36.5449 26.5676 39.7418 23.9508 44.4984 23.9508C54.4113 23.9508 56.2418 30.4734 56.2418 38.9555V56.2418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5809 56.7418H20.0809V56.2418V24.7371V24.2371H19.5809H9.78399H9.28399V24.7371V56.2418V56.7418H9.78399H19.5809ZM56.2418 56.7418H56.7418V56.2418V38.9555C56.7418 34.7035 56.2886 30.8258 54.5104 28.0057C52.6989 25.1327 49.578 23.4508 44.4984 23.4508C40.3387 23.4508 37.3001 25.3762 35.6141 27.5524V24.7371V24.2371H35.1141H25.7297H25.2297V24.7371V56.2418V56.7418H25.7297H35.5008H36.0008V56.2418V40.6699C36.0008 38.6227 36.198 36.7113 36.9621 35.3211C37.3377 34.6378 37.8482 34.0847 38.5441 33.6984C39.2429 33.3106 40.1582 33.0746 41.366 33.0746C42.543 33.0746 43.3839 33.3489 43.9962 33.7767C44.6095 34.2052 45.0362 34.8175 45.3321 35.5668C45.9353 37.0943 45.9578 39.0814 45.9578 40.9277V56.2418V56.7418H46.4578H56.2418ZM4.87266 0.5H61.1145C63.5456 0.5 65.5 2.41606 65.5 4.75664V61.2434C65.5 63.5719 63.5447 65.5 61.1145 65.5H4.87266C2.44503 65.5 0.5 63.5745 0.5 61.2305V4.75664C0.5 2.41436 2.44325 0.5 4.87266 0.5ZM8.49766 14.7727C8.49766 18.182 11.2617 20.9445 14.6824 20.9445C18.0917 20.9445 20.8543 18.1676 20.8543 14.7727C20.8543 11.3641 18.091 8.60078 14.6824 8.60078C11.2617 8.60078 8.49766 11.3634 8.49766 14.7727Z",
    stroke: "#CB37FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_297_174",
    x: -17,
    y: -17,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_297_174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_297_174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4e91a1973749b090b77e4aa08e4e9bf8.svg";
export { ForwardRef as ReactComponent };